import { render } from "./Bzioup.vue?vue&type=template&id=de1c0518&scoped=true"
import script from "./Bzioup.vue?vue&type=script&lang=js"
export * from "./Bzioup.vue?vue&type=script&lang=js"

import "./Bzioup.vue?vue&type=style&index=0&id=de1c0518&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de1c0518"]])

export default __exports__